import React from "react";
import { ReactComponent as CallCenter } from "assets/icons/call-center.svg";
import { ReactComponent as Correo } from "assets/icons/correo.svg";
import { ReactComponent as Ubicacion } from "assets/icons/ubicacion.svg";

const ChannelsAttention = ({ isFooter = false }) => {
  const TitleTag = isFooter ? "h5" : "h2";
  const containerClass = `contact-info${isFooter ? " footer" : ""}`;
  const titleClass = `title-article${isFooter ? " footer" : ""}`;

  return (
    <div className={containerClass}>
      <article>
        <TitleTag className={titleClass}>
          Canales de
          <br />
          Atención
        </TitleTag>
        <section
          className={` ${isFooter && "contact-details-container-footer"} `}
        >
          <div className="contact-item">
            <CallCenter className="icon-contact" />
            <div className={`contact-details ${isFooter && "footer"}`}>
              <a href="tel:+6015520100">(601)5520100</a>
            </div>
          </div>

          <div className="contact-item">
            <Correo className="icon-contact" />
            <div className={`contact-details ${isFooter && "footer"}`}>
              <a href="mailto:sac@grupoalianzacolombia.com">
                sac@grupoalianzacolombia.com
              </a>
              <a href="mailto:reservas@grupoalianzacolombia.com">
                reservas@grupoalianzacolombia.com
              </a>
            </div>
          </div>

          <div className="contact-item">
            <Ubicacion className="icon-contact" />
            <div className={`contact-details ${isFooter && "footer"}`}>
              <p>Oficina Principal</p>
              <p>Bogotá, Calle 93B # 17-25 Oficina 309-310-311</p>
              <p>Edificio Centro Empresarial PH</p>
            </div>
          </div>
        </section>
      </article>

      <article className="openingHours">
        <TitleTag className={titleClass}>
          Horario de <br />
          Atención
        </TitleTag>
        <p>
          Lunes a viernes: <strong> 8:00 AM - 7:00 PM</strong>
        </p>
        <p>
          Sábados: <strong> 9:00 AM - 3:00 PM</strong>
        </p>
      </article>
    </div>
  );
};

export default ChannelsAttention;
